import { TaskWithActionViewModel } from 'src/components/FormForTaskWithAction/TaskWithActionViewModel';
import { TaskActionTypes } from 'src/stores/TaskWithActionStore/TaskActionTypes.types';
import { UrlHelper } from 'src/utils/UrlHelper';

type FileDownloadTaskVariables = {
    fileName?: string;
    fileDownloadUrl?: string;
};

const downloadFile = async (
    taskViewModel: typeof TaskWithActionViewModel,
    formInstance: any,
) => {
    const taskId = taskViewModel.currentTaskDefinition?.id;
    const { fileName, fileDownloadUrl } = (taskViewModel.taskVariables?.data ||
        {}) as FileDownloadTaskVariables;

    if (!fileDownloadUrl || !fileName) {
        console.error(
            `Task ${taskId}: file-download task has no fileDownloadUrl/fileName, skipping`,
        );

        return;
    }

    try {
        UrlHelper.downloadFile(`/${fileDownloadUrl}`, fileName);
    } catch (error) {
        console.error(`Task ${taskId}: file download failed`, error);

        return;
    }

    try {
        await formInstance?.createPromise;
        await formInstance?.formio?.submit();
    } catch (error) {
        console.error(`Task ${taskId}: auto-submit failed`, error);
    }
};

export const taskActionHandlers = {
    [TaskActionTypes.FILE_DOWNLOAD]: downloadFile,
};
